import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLang } from '../hooks/useLang';

const Footer = () => {
  const { t } = useTranslation();
  const { routes } = useLang();

  return (
    <footer className="py-16 px-8 lg:px-16 bg-white border-t border-gray-200" data-testid="site-footer">
      <div className="max-w-[1920px] mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8">
          {/* Logo */}
          <div className="flex flex-col items-start">
            <div className="text-xl font-light tracking-wider mb-1" style={{ fontFamily: 'monospace' }}>
              smarch
            </div>
            <div className="text-[9px] font-light tracking-widest" style={{ fontFamily: 'sans-serif' }}>
              sylvain mazaba architectes
            </div>
          </div>

          {/* Footer Navigation */}
          <nav className="flex flex-wrap gap-8 md:gap-12">
            <Link to={routes.projects} className="text-sm font-light tracking-wide text-[#d94e47] hover:opacity-70 transition-opacity duration-300">
              {t('nav.projects')}
            </Link>
            <Link to={routes.agency} className="text-sm font-light tracking-wide text-[#d94e47] hover:opacity-70 transition-opacity duration-300">
              {t('nav.agency')}
            </Link>
            <Link to={routes.careers} className="text-sm font-light tracking-wide text-[#d94e47] hover:opacity-70 transition-opacity duration-300">
              {t('nav.careers')}
            </Link>
            <Link to={routes.news} className="text-sm font-light tracking-wide text-[#d94e47] hover:opacity-70 transition-opacity duration-300">
              {t('nav.news')}
            </Link>
          </nav>
        </div>

        {/* Copyright */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            <p className="text-xs font-light text-gray-500">
              &copy; {new Date().getFullYear()} Sylvain Mazaba Architectes. {t('footer.copyright')}
            </p>
            <p className="text-xs font-light text-gray-500">
              {t('footer.addresses')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
